export default __webpack_public_path__ + "static/media/actividad-25-2.79a86f4d.mp3";